import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "../../../components/loadable/Loadable";
import PreLoginLayout from "../components/preloginlayout/PreLoginLayout";
import { componentKey, setEndpointResult, setForgotPasswordFormFields, resetEverythingOnScreen } from "./ForgotPasswordSlice";
import { componentKey as authenticationComponentKey } from "../../authentication/AuthenticationSlice";
import styles from './ForgotPassword.styles';
import { HEADING } from "../../../components/heading/constants/constants";
import { Controller, useForm } from "react-hook-form";
import HorizontalSeparator from "../../../components/separator/horizontalSeparator/HorizontalSeparator";
import { BUTTON_TYPE } from "../../../components/button/constants";
import Button from "../../../components/button/Button";
import Heading from "../../../components/heading/Heading";
import TextInput from "../../../components/input/textinput/TextInput";
import { VEC_ICON_NAME } from "../../../components/icons/constants";
import { setPasswordResetLink } from "./ForgotPasswordSaga";
import { ENDPOINT_RESULT_TYPE } from "../../constants/constants";
import { PAGE_PATH } from "../../dashboard/constants/constant";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";
import { PRE_LOGIN_LOADING_STATES, PRE_LOGIN_STATES_MESSAGE_MAP } from "../constants";
import useTxNavigate from "../../../../libs/txnavigate/TxNavigateHook";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import General from "../../../../libs/utility/General";

export default function ForgotPassword() {
    
    useGarbageCollector(componentKey);

    const { loadingState, forgotPasswordFormFields, endpointResult} = useSelector(state => state[componentKey]);
    const { isUserAuthenticated } = useSelector((state) => state[authenticationComponentKey]);
    const { register, control, handleSubmit, formState: {errors}, reset } = useForm();
    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();

    useEffect(() => {
        if(isUserAuthenticated){
            navigate(PAGE_PATH.DASHBOARD)
        }
    }, [isUserAuthenticated]);
    
    useEffect(() => {
        return () => {
            dispatch(resetEverythingOnScreen());
        };
    }, []);

    const handleReCaptchaVerify = useCallback(async () => {
        if (executeRecaptcha) {
            return await executeRecaptcha('forgot_password');
        }
        
    }, [executeRecaptcha]);

    useEffect(() => {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);
    const handleInputChange = (e, onChangeValidationController, fieldType) => {
        const { name, value } = e.target;
        onChangeValidationController(value);
        const formFields = {
            ...forgotPasswordFormFields,
            [name]: value,
        }
        dispatch(setForgotPasswordFormFields(formFields));
    };

    const handleFormSubmit = (data) => {
        //TODO: Add Gtoken
        handleReCaptchaVerify().then(token =>
            dispatch(setPasswordResetLink({ ...forgotPasswordFormFields, GRecaptchaResponse: General.handleGRecaptchaToken(token) })));
    };

    const handleEmailInputFocus = () => {
        if(endpointResult.showMessage){
            dispatch(setEndpointResult({showMessage: false, message: ""}))
        }
    }

    return <>
        <PreLoginLayout>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[PRE_LOGIN_LOADING_STATES.FORGOT_PASSWORD_PAGE_LOADING]}
                messageMap={PRE_LOGIN_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <div style={styles.passwordForm}>
                    <Heading type={HEADING.H1}>Forgot Password</Heading>
                    <form onSubmit={handleSubmit(handleFormSubmit)}>

                        <div style={styles.marginTop}>
                            <Controller
                                control={control}
                                name="email"
                                defaultValue={forgotPasswordFormFields.email}
                                rules={{ 
                                    required: "Email cannot be empty",
                                    pattern: {
                                        value: /\S+@\S+\.\S+/,
                                        message: "Email format is incorrect"
                                    }
                                }}
                                render={({ field : {value, onChange} }) => (
                                    <TextInput
                                        type={'text'}
                                        placeHolder={'Email'} 
                                        prefixProps={{ icon: VEC_ICON_NAME.EMAIL_ICON }} 
                                        name={'email'} 
                                        value={value} 
                                        onChangeCb={(e) => handleInputChange(e, onChange)} 
                                        onFocusCb={handleEmailInputFocus}
                                    />
                                )}
                            />
                            {errors.email && <span style={styles.errorMessage}>{errors.email.message}</span>}
                        </div>
                        <div style={styles.errorMessageContainer}>
                            {
                                endpointResult.showMessage ? 
                                    <div style={{...styles.errorMessage, ...(endpointResult.resulType === ENDPOINT_RESULT_TYPE.SUCCESS) ? styles.messageSuccess: ""}}>
                                        {endpointResult.message}
                                    </div>
                                : ""
                            }    
                            </div>
                        <div style={styles.resetButtonDiv}>
                            <Button type={BUTTON_TYPE.PRIMARY}>
                                Request Reset Link
                            </Button>
                        </div>
                    </form>
                    <div style={styles.separatorDiv}><HorizontalSeparator /></div>
                    <div style={styles.signInOptionContainer}>
                        <span>Back to</span>
                        <div>
                            <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={{...styles.forgotPasswordLink, ...styles.signInLink}} onClickCb={() => {navigate('/signin')}}>
                                Sign In
                            </Button>
                        </div>
                    </div>
                </div>
            </Loadable>
        </PreLoginLayout>
    </>
}